import BaseCharacter from '@/objects/baseCharacter';

export default class DressupCharacter extends BaseCharacter {
  /**
   *  A simple prefab (extended game object class), displaying a spinning
   *  Phaser 3 logo.
   *
   *  @extends Phaser
   *
   *
   */

  constructor(scene, id, character, skin, animations, sfx, slotDefs) {
    super(scene, id, character, skin, animations, sfx);
    this.slotDefs = slotDefs;
    this.dressupData = scene.cache.json.get('data').dressupConfig;
    this.currentAnim = this.animations.default;
    this.activeSlots = [];
    this.scaleMultiplier = 0.3;
    scene.add.existing(this);
    this.dancing = false;
    this.danceTime = 2300;
    this.danceCounter = 0;

    this.giggling = false;
    this.giggleTime = 0;
    this.giggleCounter = 0;
    this.giggleIdx = 0;

    this.frozen = false;
    this.clothes = scene.add.container(0, 0);
    this.clothes.setPosition(0, 0);
    this.clickArea
      .setInteractive({
        useHandCursor: true
      })
      .on(
        'pointerdown',
        function (pointer) {
          this.handleCharacterClicked(this.ID, pointer);
        },
        this
      );

    this.initActiveSlots();

  }

  initActiveSlots() {
    for (let i = 0; i < this.slotDefs.length; i++) {
      if (Array.isArray(this.slotDefs[i])) {
        for (let j = 0; j < this.slotDefs[i].length; j++) {
          let slot = this.spineChar.skeleton.findSlot(this.slotDefs[i][j]);
          if (slot !== undefined && slot !== null) {
            this.setAttachment(this.slotDefs[i][j], null);
            this.activeSlots.push(slot);
          }
        }
      } else {
        let slot = this.spineChar.skeleton.findSlot(this.slotDefs[i]);
        if (slot !== undefined && slot !== null) {
          this.setAttachment(this.slotDefs[i], null);
          this.activeSlots.push(slot);
        }
      }
    }
  }

  kill() {
    this.clickArea.off('pointerdown');
  }

  freeze(scene, anim, time) {
    this.spineChar.addAnimation(0, anim, false);
    let track = this.spineChar.state.getCurrent(0);
    if (track !== undefined) {
      track.trackTime = time;
      this.spineChar.state.apply(this.spineChar.skeleton);
      this.spineChar.state.timeScale = 0;
    }
    // this.spineChar.state.setCurrentTime(time);
  }

  setTransform(posX, posY, scaleX, scaleY, dir) {
    super.setTransform(posX, posY, scaleX, scaleY, dir);
    this.charScale = scaleX;
    this.charScaleX = Math.abs(scaleX);
    this.charScaleY = Math.abs(scaleY);
  }


  randomPointInBounds() {
    let padding = 80;//100;
    let width = Math.abs(this.clickArea.displayWidth / 2);
    let height = this.clickArea.displayHeight;
    return {
      x:
        this.transform.x +
        Phaser.Math.Between(padding - width, width - padding),
      y: this.transform.y - Phaser.Math.Between(padding, height - padding)
    };
  }

  populateSlots(scene, slotItems, placedItems, itemScale) {
    this.activeSlots = slotItems;
    this.itemScale = itemScale;
    for (var i = 0; i < slotItems.length; i++) {
      let slotItem = slotItems[i];
      slotItem.freePlace = false;
      slotItem.name = slotItems[i].item;
      let overrideSlot = slotItem.overrideSlot;
      this.setAttachment(slotItem.slot, slotItem.attachment);
      if (overrideSlot === undefined) {
        this.addAttachmentAsSprite(scene, slotItem);
      } else if (overrideSlot.noSprite === false) {
        this.addAttachmentAsSprite(scene, slotItem, overrideSlot.spriteName);
      }
    }

    let scale = itemScale;//(this.charScale / this.scaleMultiplier);// * this.itemScale;
    for (var j = 0; j < placedItems.length; j++) {
      let spr = placedItems[j];
      let offsetX = spr.x * this.charWidth;
      let offsetY = spr.y * this.charHeight;
      let item = scene.add.image(
        this.transform.x + offsetX,
        this.transform.y + offsetY,
        'freeplaceItems',
        spr.sprite + '.png'
      );

      item.freePlace = true;
      let itemScaleX = item.width * scale;
      let itemScaleY = item.height * scale;
      item.setDisplaySize(itemScaleX, itemScaleY);// *= scale;
      //item.displayHeight *= scale;
      this.clothes.add(item);
    }
  }

  handleCharacterClicked(id, pointer) {
    if (this.charActive) { this.emitter.emit('characterClicked', id, pointer); }
  }

  getNormalizedPosition(x, y) {
    let normX = (x - this.transform.x) / this.charWidth;
    let normY = (y - this.transform.y) / this.charHeight;
    return {
      x: normX,
      y: normY
    };
  }

  addItem(scene, item) {
    // let itemPivot = scene.add.container(item.x, item.y, [item]);
    // let itemHolder = scene.add.container(itemPivot.x, 0, [itemPivot]);
    this.clothes.add(item);
  }

  getClosestSlot(x, y) {
    let minDist = 100;
    let closestSlot = null;

    for (let i = 0; i < this.slotDefs.length; i++) {
      let bone = this.activeSlots[i].bone;
      let boneX = this.transform.x + bone.worldX * this.spineChar.scaleX;
      let boneY = this.transform.y - bone.worldY * this.spineChar.scaleY;
      let dist = this.distance(x, y, boneX, boneY);
      let attachment = this.activeSlots[i].attachment;
      if (attachment !== null && dist < minDist) {
        minDist = dist;
        closestSlot = this.slotDefs[i];
      }
    }

    return closestSlot;
  }

  getSlotFromPosition(x, y) {
    return this.getClosestSlot(x, y);
  }

  distance(x1, y1, x2, y2) {
    let a = x1 - x2;
    let b = y1 - y2;
    return Math.sqrt(a * a + b * b);
  }

  toggleEyes(eyesOpen) {
    // let eyeLeft = this.spineChar.skeleton.findSlot("Openeye_L");
    // let eyeRight = this.spineChar.skeleton.findSlot("Openeye_R");
    if (eyesOpen) {
      this.setAttachment('Openeye_L', 'Openeye_L');
      this.setAttachment('Openeye_R', 'Openeye_R');
    }
    else {
      this.setAttachment('Openeye_L', 'Openeye_L_empty');
      this.setAttachment('Openeye_R', 'Openeye_R_empty');
    }

  }

  addAttachmentAsSprite(scene, slotItem, spriteName) {

    let slot = this.spineChar.skeleton.findSlot(slotItem.slot);
    let bone = slot.bone;
    let boneX = this.transform.x + bone.worldX * this.spineChar.scaleX;
    let boneY = this.transform.y - bone.worldY * this.spineChar.scaleY;
    var item = null;
    if (spriteName !== undefined) {
      let spritePath = spriteName + '.png';
      item = scene.add.sprite(0, 0, 'freeplaceItems', spritePath);
    } else {

      item = this.spineChar.skeleton.atlas.getImageFromRegion(
        scene,
        slotItem.attachment
      );

      if (item == null) {
        item = this.spineChar.skeleton.atlas.getImageFromRegion(
          scene,
          slotItem.item
        );
      }
    }

    if (item != null) {
      let scale = this.charScale / this.scaleMultiplier;
      item.scaleX = scale * window.spriteScaler;
      item.scaleY = scale * window.spriteScaler;

      let itemPivot = scene.add.container(0, 0, [item]);
      let itemHolder = scene.add.container(0, 0, [itemPivot]);
      itemHolder.itemName = slotItem.item;
      itemHolder.freePlace = false;
      this.clothes.add(itemHolder);
      itemHolder.x = boneX;
      itemHolder.y = boneY;
      itemPivot.x = 0;
      itemPivot.y = 0;
      let boneAngle = bone.getWorldRotationX();

      itemPivot.angle = boneAngle;
      itemHolder.alpha = 0;
    }
  }

  wrap(value) {
    return value % 360;
  }

  animateClothes(scene, freePlaceOnly) {
    for (var i = 0; i < this.activeSlots.length; i++) {
      for (var j = 0; j < this.dressupData.items.length; ++j) {
        if (this.dressupData.items[j].icon === this.activeSlots[i].item) {
          if (!freePlaceOnly || this.dressupData.items[j].freePlace == 'true') {
            this.setAttachment(this.activeSlots[i].slot, null);
          }
        }
      }
    }
    this.clothes.depth = 5;

    for (var l = 0; l < this.clothes.length; l++) {
      let item = this.clothes.getAt(l);

      if (item != null) {
        let itemIsFreeplace = true;
        if (!item.freePlace) {
          for (var k = 0; k < this.dressupData.items.length; ++k) {
            if (this.dressupData.items[k].icon === item.itemName) {

              let fp = this.dressupData.items[k].freePlace == 'true' ? true : false;
              if (fp === undefined) {
                fp = false;
              }

              itemIsFreeplace = fp;
            }
          }
        }

        if (item.freePlace && freePlaceOnly || !freePlaceOnly || itemIsFreeplace) {

          item.depth = 0;
          // console.log('moving item from ' + item.x + ', ' + item.y);
          let dir = item.x - this.transform.x > 0 ? 1 : -1;
          let tweenX = item.x + dir * Phaser.Math.Between(100, 300);
          let tweenY = item.y - Phaser.Math.Between(50, 75);
          let floorY = this.transform.y;
          let tweenAngle = Phaser.Math.Between(-360, 360);
          item.alpha = 1;
          scene.characterGroup.add(item);
          scene.tweens.add({
            targets: item,
            x: tweenX,
            duration: 2000
          });
          scene.tweens.add({
            targets: item,
            y: tweenY,
            duration: 1000,
            ease: 'Cubic.easeOut'
          });
          scene.tweens.add({
            targets: item,
            y: floorY,
            duration: 1000,
            delay: 1000,
            ease: 'Bounce.easeOut',
            easeParams: [Phaser.Math.Between(100, 200) * 0.01]
          });
          scene.tweens.add({
            targets: item,
            angle: tweenAngle,
            duration: 1750,
            ease: 'Quad.easeOut'
          });
          scene.tweens.add({
            targets: item,
            alpha: 0,
            duration: 500,
            delay: 1750,
            onComplete: () => {
              item.destroy();
            }
          });
        }
      }
    }

    // scene.sound.play(this.sfx.shake);
    // this.togglePause(scene);
    this.spineChar.state.timeScale = 1;
    if (!freePlaceOnly) {
      this.playAnim(scene, this.animations.shake, 0.1, false, false);
    }
  }

  startMove(scene) {
    this.playAnim(scene, this.animations.default, 0.33, true);
    this.playing = true;
    //this.canIdle = true;
  }

  startDance(scene, immediate = true) {
    // let offset = Phaser.Math.Between(0, 3);
    this.dancing = true;
    this.idleActive = false;
    // this.giggling = false;
    this.canIdle = false;
    this.toggleEyes(false);
    this.danceIdx = 0;//Phaser.Math.Between(0, this.animations.dance.length - 1);
    if (immediate) {
      this.playDance(scene);
    }
    else {
      this.danceTime = 500;
    }
  }

  startGiggle(scene) {
    // let offset = Phaser.Math.Between(0, 3);
    this.dancing = false;
    this.idleActive = false;
    this.giggling = true;
    this.canIdle = false;
    this.giggleTime = 2000;
    this.giggleCounter = 0;
    this.giggleIdx = 0;//Phaser.Math.Between(0, this.animations.dance.length - 1);

    scene.time.delayedCall(Phaser.Math.Between(0, 500), () => {
      this.playHappy(scene, true);
    });
  }

  danceThenAnimateClothes(scene, callback) {
    // this.toggleFreeze();
    //this.startDance(scene);

    this.animateClothes(scene, true);

    let track = this.spineChar.state.getCurrent(0);
    if (this.idleAnims.includes(track.animation.name)) {
      this.startDance(scene);
    }
    else {
      this.dancing = true;
      this.danceIdx = 0;
      this.danceCounter = this.spineChar.state.getCurrent(0).getAnimationTime() / 0.001;
      this.danceTime = this.spineChar.state.getCurrent(0).getAnimationLength() / 0.001;
    }

    scene.time.delayedCall(4000, () => {
      this.dancing = false;
      this.animateClothes(scene);
      this.toggleEyes(false);
    });
    scene.time.delayedCall(6000, () => {
      this.startDance(scene);
      callback();
    });
  }

  updateCharacter(time, delta, scene) {
    super.updateCharacter(time, delta, scene);

    if (this.dancing == true && !this.giggling) {
      if (this.danceCounter >= this.danceTime) {
        if (this.animations.dance.length > 1) {
          this.danceIdx = (this.danceIdx + 1) % this.animations.dance.length;
          this.playDance(scene);
        }
      } else {
        this.danceCounter += delta;
      }
    }

    if (this.giggling == true) {
      if (this.giggleCounter >= this.giggleTime) {
        if (this.dancing) {
          // this.danceCounter = 0;
          // this.danceTime = 3000;
          this.giggling = false;
        }
        else {
          if (this.animations.happy.length > 1) {
            this.giggleIdx = (this.giggleIdx + 1) % this.animations.happy.length;
            this.playHappy(scene, true);
          }
        }
      } else {
        this.giggleCounter += delta;
      }
    }
  }

  playHappy(scene, loop) {
    var danceMix = 0.05;
    this.lastDanceAnim = this.danceAnim;
    this.giggleAnim = this.animations.happy[this.giggleIdx];
    this.playAnim(
      scene,
      this.giggleAnim,
      danceMix,
      false,
      false
    );

    if (this.sfx.hasOwnProperty(this.giggleAnim)) {
      scene.sound.play(this.sfx[this.giggleAnim]);
    }

    if (loop) {
      this.giggleTime = 2000 + Phaser.Math.Between(0, 500);
      this.giggleCounter = 0;
      this.giggling = true;
    }
    else {
      this.giggling = false;
    }
    // super.playHappy(scene);
  }

  playDance(scene) {
    var danceMix = 0.05;
    this.lastDanceAnim = this.danceAnim;
    this.danceAnim = this.animations.dance[this.danceIdx];
    this.playAnim(
      scene,
      this.danceAnim,
      danceMix,
      false,
      false
    );
    super.setTimescale(0.95, 1.05);
    this.lastDanceLength = this.danceLength;

    this.danceLength = (this.spineChar.state.getCurrent(0).getAnimationLength() + danceMix);
    if (this.lastDanceAnim !== undefined) {
      //console.log(this.name + ' --> DANCE --> from ' + this.lastDanceAnim + ' (' + this.lastDanceLength.toFixed(2) + ') to ' + this.danceAnim + ' (' + this.danceLength.toFixed(2) + ')');
    }
    this.danceTime = Phaser.Math.Between(0, 500) + this.danceLength / 0.001;
    this.danceCounter = 0;
  }

  randomRange(min, max, round = false) {
    if (round) {
      return Phaser.Math.Between(min, max);
    } else {
      return Phaser.Math.Between(min * 100, max * 100) / 100;
    }
  }

  setAttachment(slotName, attachmentName) {
    this.spineChar.skeleton.setAttachment(slotName, attachmentName);
  }


  toggleFreeze(/* scene */) {
    if (this.playing == true) {
      let track = this.spineChar.state.getCurrent(0);
      if (track !== undefined) {
        this.freezeTime = track.getAnimationTime();
      }
      this.spineChar.state.timeScale = 0;
      // this.moveTween.pause();
      this.dancing = false;
      this.frozen = true;
      // this.wiggle(scene);
      this.playing = false;
      this.toggleEyes(true);
    } else {
      this.spineChar.state.timeScale = 1;
      this.frozen = false;
      this.playing = true;
      this.toggleEyes(false);
    }
  }

  wiggle(scene) {
    let offset = 5 * this.direction;
    this.transform.x -= offset;
    let wiggleX = this.transform.x + offset;
    this.wiggleTween = scene.tweens.add({
      targets: this.transform,
      x: wiggleX,
      duration: 300,
      ease: 'Bounce.easeOut'
    });
  }

  destroy() {
    if (this.clothes != null) {
      for (var i = this.clothes.length - 1; i >= 0; i--) {
        if (this.clothes[i] != undefined) {
          this.clothes[i].destroy();
          this.clothes[i] = null;
        }
      }
    }
    this.clothes = null;
    this.moveTween = null;
    super.destroy();
  }
}
